import { createEndpoint } from '@/shared/models/api';
import { ConverterRequest } from '@/app/api/morgan-thermal/converter';

export const convertTemperature = createEndpoint<number>(({fetch}) => ({ isMetric, value }: ConverterRequest) => fetch(`/Converter/Temperature/${isMetric}/${value}`));